import axios from 'axios';

// eslint-disable-next-line typescript/no-explicit-any -- Pre-existing any
export type Response<T = any> = {
  data: T;
};

export type HttpClient = {
  get: <T>(url: string) => Promise<Response<T>>;
  post?: <T>(url: string, data?: any) => Promise<Response<T>>; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
  put?: <T>(url: string, data?: any) => Promise<Response<T>>; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
  delete?: <T>(url: string) => Promise<Response<T>>;
};

export const defaultHttpClient: HttpClient = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};
